import RangesToCharacters from "../../../../src/components/RangesToCharacters";
import WorkSansFontFace from "../../../../content/posts/work-sans-typeface-notes/WorkSansFontFace";
import WorkSansSnippet from "../../../../content/posts/creating-font-subsets/WorkSansSnippet";
import * as React from 'react';
export default {
  RangesToCharacters,
  WorkSansFontFace,
  WorkSansSnippet,
  React
};